export default __webpack_public_path__ + "static/LeituraSansTwo-LightItalic-f547fc61331734c64dc8c1c516394d76.woff";